import React from 'react';
import { Clock, AlertCircle } from 'lucide-react';
import { useReservationTimer } from '../hooks/useReservationTimer';

interface ReservationBadgeProps {
  expiresAt: string | null | undefined;
  dealerName?: string;
  isMyReservation?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function ReservationBadge({
  expiresAt,
  dealerName,
  isMyReservation = false,
  size = 'md'
}: ReservationBadgeProps) {
  const { formatShort, isExpired, isExpiringSoon } = useReservationTimer(expiresAt ?? null);

  if (isExpired) {
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 text-xs font-medium bg-[var(--glass-hover-bg,rgba(0,0,0,0.04))] text-[var(--glass-text-primary,#242424)]" style={{ borderRadius: '6px' }}>
        <Clock className="w-3 h-3 mr-1" />
        Libera
      </span>
    );
  }

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <div className={`inline-flex flex-col ${isMyReservation ? 'items-end' : 'items-start'}`}>
      <span
        className={`
          inline-flex items-center font-medium
          ${sizeClasses[size]}
          ${isExpiringSoon 
            ? 'bg-[var(--badge-error-bg,rgba(239,68,68,0.1))] text-[var(--badge-error-text,#ef4444)] animate-pulse' 
            : isMyReservation 
              ? 'bg-[var(--badge-success-bg,rgba(34,197,94,0.15))] text-[var(--badge-success-text,#22c55e)]'
              : 'bg-[var(--badge-warning-bg,rgba(245,158,11,0.15))] text-[var(--badge-warning-text,#f59e0b)]'
          }
        `}
        style={{ borderRadius: '6px' }}
      >
        {isExpiringSoon && <AlertCircle className={`${iconSizes[size]} mr-1`} />}
        <Clock className={`${iconSizes[size]} mr-1`} />
        {isMyReservation ? 'La tua prenotazione: ' : 'In trattativa: '}
        <span className="font-bold ml-1">{formatShort()}</span>
      </span>
      {dealerName && !isMyReservation && (
        <span className="text-xs text-[var(--glass-text-secondary,#898989)] mt-1">
          da {dealerName}
        </span>
      )}
    </div>
  );
}

export default ReservationBadge;
